const calculateScrollbarWidth = () => {
  document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');
};
window.addEventListener('resize', calculateScrollbarWidth);
document.addEventListener('DOMContentLoaded', calculateScrollbarWidth);
window.addEventListener('load', calculateScrollbarWidth);
